import _ from 'lodash';

const COOKIE_NAME = 'timezone-offset';

_.mixin({
  /**
   * Set a time zone offset in cookie
   * */
  setTimezoneCookie: () => {
    const cookie = _.getCookie(COOKIE_NAME);
    const timezoneOffset = new Date().getTimezoneOffset();
    if (cookie == null || cookie !== timezoneOffset) {
      _.setCookie(COOKIE_NAME, timezoneOffset, 0);
    }
  },
  /**
   * Get a time zone offset in cookie
   * */
  getTimezoneCookie: () => {
    return _.getCookie(COOKIE_NAME);
  }
});
